import lineStyle from './funnel.data.labelLine.lineStyle'

export default {
  name: "labelLine",
  nickname: "引导线样式",
  desc: "labelLine",
  type: "object",
  props: {
    show: {
      name: "show",
      nickname: "显示",
      desc: "是否显示视觉引导线。",
    },
    length: {
      name: "length",
      nickname: "长度",
      desc: "视觉引导线的长度。",
    },
    lineStyle,
  },
}
